import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "../AppIcon";
import LanguageSwitcher from "../LanguageSwitcher";
import { useAuth } from "../../contexts/AuthContext";

const Header = () => {
  const { t } = useTranslation();
  const [menuOpened, setMenuOpened] = useState(false);
  const navigate = useNavigate();
  const {
    isAuthenticated,
    hasPaid,
    hasCompletedAssessment,
    logout,
    loginWithGoogle,
  } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Navigation items: different based on authentication status
  const allNavigationItems = [
    {
      label: t("navigation.home"),
      authLabel: t("navigation.dashboard"),
      path: "/landing-page",
      icon: "Home",
      requireAuth: false,
      requirePayment: false,
    },
    {
      label: t("navigation.assessment"),
      path: "/assessment-questionnaire",
      icon: "ClipboardList",
      requireAuth: false,
      requirePayment: false,
    },
    {
      label: t("navigation.nutrition"),
      authLabel: t("navigation.nutritionHub"),
      path: "/nutrition-hub",
      icon: "Apple",
      requireAuth: true,
      requirePayment: true,
    },
    {
      label: t("navigation.mentalWellness"),
      authLabel: t("navigation.mentalNeuro"),
      path: "/mental-neuro-section",
      icon: "Brain",
      requireAuth: true,
      requirePayment: true,
    },
  ];

  // Filter navigation items based on auth status and payment status
  const navigationItems = allNavigationItems.filter((item) => {
    // Hide assessment if authenticated and completed
    if (
      item.path === "/assessment-questionnaire" &&
      isAuthenticated &&
      hasCompletedAssessment
    ) {
      return false;
    }
    // Show if doesn't require auth
    if (!item.requireAuth) return true;
    // Show if authenticated and doesn't require payment
    if (isAuthenticated && !item.requirePayment) return true;
    // Show if authenticated and has paid
    if (isAuthenticated && hasPaid) return true;
    // Otherwise hide
    return false;
  });

  const isActive = (path: string) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // return (
  //   <header className="sticky top-0 z-[100] bg-black">
  //     <div className="flex items-center h-16 px-4 md:px-6">
  //       <Link to="/landing-page" className="flex items-center space-x-2 mr-6">
  //         <div className="w-10 h-10 bg-accent/10 rounded flex items-center justify-center transition-all duration-150 ease-out hover:bg-accent/20">
  //           <Icon
  //             name="Flame"
  //             size={24}
  //             color="var(--color-accent)"
  //             strokeWidth={2}
  //           />
  //         </div>
  //         <span className="font-heading font-bold text-xl hidden sm:inline-block text-white">
  //           FireUp
  //         </span>
  //       </Link>

  //       <nav className="hidden md:flex items-center space-x-1 flex-1">
  //         {navigationItems?.slice(0, 5)?.map((item) => (
  //           <Link
  //             key={item?.path}
  //             to={item?.path}
  //             className={`px-4 py-2 rounded font-body font-semibold text-sm transition-all duration-150 ease-out ${
  //               isActive(item?.path)
  //                 ? "bg-accent text-accent-white"
  //                 : "text-white hover:bg-muted hover:text-black"
  //             }`}
  //           >
  //             {item?.label}
  //           </Link>
  //         ))}

  //         {/* <div className="relative group">
  //           <button className="px-4 py-2 rounded font-body font-semibold text-sm text-foreground hover:bg-muted transition-all duration-150 ease-out flex items-center space-x-1">
  //             <span>More</span>
  //             <Icon name="ChevronDown" size={16} />
  //           </button>
  //           <div className="absolute top-full left-0 mt-1 w-48 bg-popover border border-border rounded shadow-modal opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 ease-out">
  //             {navigationItems?.slice(4)?.map((item) => (
  //               <Link
  //                 key={item?.path}
  //                 to={item?.path}
  //                 className={`block px-4 py-2 text-sm font-body hover:bg-muted transition-all duration-150 ease-out ${
  //                   isActive(item?.path)
  //                     ? "bg-accent text-accent-foreground"
  //                     : "text-popover-foreground"
  //                 }`}
  //               >
  //                 {item?.label}
  //               </Link>
  //             ))}
  //           </div>
  //         </div> */}
  //       </nav>

  //       <div className="ml-auto flex items-center space-x-3">
  //         <LanguageSwitcher />
  //         {isAuthenticated ? (
  //           <>
  //             <button
  //               onClick={() => navigate("/dashboard")}
  //               className="hidden md:flex items-center space-x-2 px-4 py-2 rounded bg-accent text-accent-foreground font-semibold text-sm hover:bg-accent/90 transition-all duration-150 ease-out"
  //             >
  //               <Icon name="Home" size={16} />
  //               <span>{t("common.dashboard") || "Dashboard"}</span>
  //             </button>
  //             <button
  //               onClick={async () => {
  //                 await logout();
  //                 navigate("/");
  //               }}
  //               className="hidden md:flex items-center space-x-2 px-4 py-2 rounded bg-muted text-foreground font-semibold text-sm hover:bg-muted/80 transition-all duration-150 ease-out"
  //             >
  //               <Icon name="LogOut" size={16} />
  //               <span>{t("common.logout") || "Logout"}</span>
  //             </button>
  //           </>
  //         ) : (
  //           <button
  //             onClick={() => loginWithGoogle()}
  //             className="hidden md:flex items-center space-x-2 px-4 py-2 rounded bg-accent text-accent-foreground font-semibold text-sm hover:bg-accent/90 transition-all duration-150 ease-out"
  //           >
  //             <Icon name="LogIn" size={16} />
  //             <span>{t("common.login") || "Login"}</span>
  //           </button>
  //         )}
  //         <button
  //           onClick={toggleMobileMenu}
  //           className="md:hidden p-2 rounded hover:bg-muted hover:text-black text-white transition-all duration-150 ease-out"
  //           aria-label={t("header.toggleMenu")}
  //         >
  //           <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
  //         </button>
  //       </div>
  //     </div>
  //     {isMobileMenuOpen && (
  //       <div className="md:hidden border-t border-border bg-background">
  //         <nav className="flex flex-col p-4 space-y-2">
  //           {navigationItems?.map((item) => (
  //             <Link
  //               key={item?.path}
  //               to={item?.path}
  //               onClick={() => setIsMobileMenuOpen(false)}
  //               className={`flex items-center space-x-3 px-4 py-3 rounded font-body font-semibold text-sm transition-all duration-150 ease-out ${
  //                 isActive(item?.path)
  //                   ? "bg-accent text-accent-whitte"
  //                   : "text-whitte hover:bg-muted"
  //               }`}
  //             >
  //               <Icon name={item?.icon} size={20} />
  //               <span>{item?.label}</span>
  //             </Link>
  //           ))}
  //         </nav>
  //       </div>
  //     )}
  //   </header>
  // );

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/60 backdrop-blur-xl border-b border-white/5">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <a href="#" className="text-xl font-bold text-foreground">
          FireUP
        </a>
        <nav className="hidden md:flex items-center gap-8">
          <a
            href="#"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("landingPage.header.home")}
          </a>
          <a
            href="#about"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("landingPage.header.about")}
          </a>
          <a
            href="#faqs"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("landingPage.header.faqs")}
          </a>
        </nav>
        <div className="hidden md:flex items-center gap-4">
          <LanguageSwitcher />
          <a href="/book-a-call" className="btn-primary-glow !py-2.5 !px-5">
            <span>{t("landingPage.header.bookCall")}</span>
            <span className="btn-arrow-container !w-6 !h-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right w-3 h-3 arrow-right"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right w-3 h-3 arrow-left"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </span>
          </a>
        </div>
        <button
          className="md:hidden text-foreground"
          onClick={() => setMenuOpened(!menuOpened)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-menu"
          >
            <line x1={4} x2={20} y1={12} y2={12} />
            <line x1={4} x2={20} y1={6} y2={6} />
            <line x1={4} x2={20} y1={18} y2={18} />
          </svg>
        </button>
      </div>
      {menuOpened && (
        <nav className="md:hidden border-t border-b-2 border-border px-4 py-6 space-y-4">
          <a
            href="#"
            className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("landingPage.header.home")}
          </a>
          <a
            href="#about"
            className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("landingPage.header.about")}
          </a>
          <a
            href="#faqs"
            className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("landingPage.header.faqs")}
          </a>
          <a
            href="/book-a-call"
            className="block text-sm hover:text-foreground transition-colors font-bold text-primary"
          >
            {t("landingPage.header.bookCall")}
          </a>
          <div className="pt-2">
            <LanguageSwitcher />
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
